import { useEffect } from "react";
import useAdManagerService from './useAdManagerService';

const useAdUnit = (adManager, adUnitConfig) => {
  const { isInitialized } = useAdManagerService(adManager);

  useEffect(() => {
    if (!adManager || !isInitialized || !adUnitConfig) {
      return;
    }

    const {adUnit, slotId} = adUnitConfig;

    if (!adUnit) return;

    adManager.initializeUnit(adUnitConfig);

    return () => {
      adManager.destroyUnits([slotId]);
    };
  }, [adUnitConfig, isInitialized]);
};

export default useAdUnit;